export default function Privacy() {
  return (
    <iframe
      className="w-screen h-full"
      src="https://www.schoolscoolamsterdam.nl/privacyverklaring/"
    />
  );
}
